import React from 'react';
import moment from "moment";
import PropTypes from "prop-types";

class UsersPaginations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            itemsPerPage: 100,
            selectedSample: null,
            filterUsers: [],
            totalUsers: 0,
            propSurveyStatus: this.props.surveyStatus,
        };
    }

    componentDidMount() {
        this.setState({ filterUsers: this.props.users })
    }

    render() {
        const { users, totalResponseData, currentPageNumber, pageSize } = this.props;

        return (
            <div className="mt-5">
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>User Id</th>
                        {this.state.propSurveyStatus != "Test" ? <>
                            <th>Name</th>
                            <th>Gender</th>
                        </> : ""}
                        <th>Status</th>
                        <th>Started At</th>
                        <th>Link</th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map((info, index) => (
                        <tr key={info.userId + index}>
                            <td>{((parseInt(totalResponseData))-(pageSize*(currentPageNumber-1)))-(index)}</td>
                            <td>{info.userId ? info.userId : '-'}</td>
                            {this.state.propSurveyStatus != "Test" ? <>
                                <td>{info.userName ? info.userName : '-'}</td>
                                <td>{info.gender ? info.gender : '-'}</td>
                            </> : ""}
                            <td>{info.status ? info.status : '-'}</td>
                            <td>{moment(info.createdAt).format('MM/DD/YYYY HH:mm A')}</td>
                            <td>
                                {info.surveylink ? (
                                    <a href={info.surveylink} target="_blank"
                                       rel="noopener noreferrer">
                                        Click here to start survey
                                    </a>
                                ) : 'NA'}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

UsersPaginations.propTypes = {
    users: PropTypes.array,
    surveyStatus: PropTypes.string,
    totalResponseData: PropTypes.any,
    currentPageNumber: PropTypes.any,
    pageSize: PropTypes.any,
}
export default UsersPaginations;
